export const searchConfig = {
    sourceLanguageLocalStorageKey: 'searchSourceLanguage',
    targetLanguageLocalStorageKey: 'searchTargetLanguage',
    knowsHowToAddLocalStorageKey: 'searchKnowsHowToAdd',
};
